module.exports = __webpack_public_path__ + "media/bootstrap-icons/credit-card-fill-615b6011.svg";